
/**
 * 关键路线接口服务（纯接口请求）
 */
export const thematicRouteService = {
  /**
   * 后台某个关键路线的详情
   * @returns {Promise<Response>} 后端原始响应
   */
  getDetail: ({ id }) => {
    console.log("参数：",id)
    return fetch(`/qhkj-agri-map-api/base/thematic/route/getDetail?id=${id}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    });
  }
};